import React from 'react';
import { Stack, Button } from '@mui/material';
import { DialogContainer, DialogTitle, DialogContent, DialogActions } from '/packages/shared-components/Dialog/Dialog';

export interface ConfirmSwitchModalProps {
  partnerName: string;
  id: string;
  handleSwitchPartnerConfirm: (path: string) => void;
  handleModalClose: () => void;
}

export const ConfirmSwitchModal = ({
  partnerName,
  id,
  handleSwitchPartnerConfirm,
  handleModalClose,
}: ConfirmSwitchModalProps) => {
  const handleConfirm = () => {
    handleSwitchPartnerConfirm(id);
  };

  return (
    <DialogContainer size="S">
      <DialogTitle>Switch Partner</DialogTitle>
      <DialogContent>You are about to navigate to the {partnerName} partner space.</DialogContent>
      <DialogActions>
        <Stack direction="row" gap={2}>
          <Button color="primary" variant="text" aria-label="Cancel" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button color="primary" variant="contained" aria-label="Confirm" onClick={handleConfirm}>
            Confirm
          </Button>
        </Stack>
      </DialogActions>
    </DialogContainer>
  );
};
